import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionIssue, TransactionIssueCount, TransactionIssueType } from '../../../services/transaction.types';
import AutocompleteFilter, { FilterOption } from './AutocompleteFilter';

const Flagged: FC<{ transactionIssues: TransactionIssue[]; allTimeIssueCount?: TransactionIssueCount; value?: string[]; onChange: (value: string[]) => void }> = ({
    transactionIssues,
    allTimeIssueCount,
    value = [],
    onChange,
}) => {
    const { t } = useTranslation();
    const options: FilterOption[] = (transactionIssues || [])
        .map((issue) => {
            let count = 0;
            
            // Map issue ID to the corresponding count from allTimeIssueCount
            if (allTimeIssueCount) {
                switch (issue.id) {
                    case TransactionIssueType.MissingPrice: // Missing Price
                        count = allTimeIssueCount.missingAssetValueCount || 0;
                        break;
                    case TransactionIssueType.MissingCostBasis: // Missing Cost Basis
                        count = allTimeIssueCount.costBasisCount || 0;
                        break;
                    case TransactionIssueType.IncompleteTransfer: // Incomplete Transfer
                        count = allTimeIssueCount.incompleteTransferCount || 0;
                        break;
                    case TransactionIssueType.SpamCoin: // Spam Coin
                        count = allTimeIssueCount.spamCoinCount || 0;
                        break;
                    default:
                        count = 0;
                }
            }
            
            return {
                id: issue.id,
                count,
                label: `${issue.description} (${count})`,
            };
        })
        // Filter out options with zero count if we have count data
        .filter(option => !allTimeIssueCount || option.count > 0);

    return (
        <AutocompleteFilter
            options={options}
            value={value}
            onChange={onChange}
            label="Status"
            placeholder={t('transactions.filters.flagged.placeholder')}
            sx={{ minWidth: '260px' }} // Make the filter wider to fit options in one row
        />
    );
};

export default Flagged;
